import React from 'react';
import 'core-js';
import 'bootstrap/dist/css/bootstrap.css';
import './css/webVolumeViewer.css';
import './css/globalStyles.css';
import './i18n';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { main } from './themes/main';
import theme from './themes/materialUITheme';
import { App } from './components/App/App';
import AppWithKeycloak from './components/App/AppWithKeycloak';
import { Error } from './components/Error';
import StartupValidationModal from './components/StartupValidationModal';
import GlobalStyle from './themes/GlobalStyle';
import store from './store/store';
import { useApplicationStartup } from './util/startApplication';

const ApplicationRoot = () => {
  const { startupResult, isChildViewport } = useApplicationStartup();
  const { appConfig, errorMessages = [], oidcEnabled } = startupResult || {};
  const withErrors = errorMessages.length > 0;
  const canRenderApplication = Boolean(startupResult) && !withErrors;

  const Render = ({ children }) => {
    if (!canRenderApplication) return '';
    return children;
  };

  return (
    <Provider store={store}>
      <ThemeProvider theme={main}>
        <MuiThemeProvider theme={theme}>
          <GlobalStyle />
          {withErrors && <Error message={errorMessages.join('\n')} />}
          <Render>
            {oidcEnabled && <AppWithKeycloak appConfig={appConfig} />}
            {!oidcEnabled && <App />}
          </Render>
          {!isChildViewport && <StartupValidationModal />}
        </MuiThemeProvider>
      </ThemeProvider>
    </Provider>
  );
};

ReactDOM.render(<ApplicationRoot />, document.getElementById('app'));
